import React from 'react'
// import styles from './button.module.scss'

const ButtonLoader = () => (
  <div className="loaderRootContainer">
    <div className="loaderDot delay_0s" />
    <div className="loaderDot delay_0_1s" />
    <div className="loaderDot delay_0_2s" />
  </div>
)

export default ButtonLoader
